import { render, staticRenderFns } from "./ProductComparison.vue?vue&type=template&id=481926ec&"
import script from "./ProductComparison.vue?vue&type=script&lang=js&"
export * from "./ProductComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports